import { createContext, useContext, useState, useEffect } from 'react';

const SessionContext = createContext(null);

export function useSession() {
    const context = useContext(SessionContext);
    if (!context) {
        throw new Error('useSession must be used within SessionContextProvider');
    }
    return context;
}

export function SessionContextProvider({ children }) {
    const [brands, setBrandsState] = useState([]);
    const [models, setModelsState] = useState([]);
    const [productTypes, setProductTypesState] = useState([]);
    const [stage, setStageState] = useState(0);
    const [service, setServiceState] = useState(null);
    const [payment, setPaymentState] = useState(null);

    useEffect(() => {
        try {
            const safeParse = (key) => {
                const raw = sessionStorage.getItem(key);
                return raw ? JSON.parse(raw) : null;
            };

            const savedBrands = safeParse('brands') || [];
            const savedModels = safeParse('models') || [];
            const savedProductTypes = safeParse('productTypes') || [];
            const savedStage = parseInt(sessionStorage.getItem('stage') || '0', 10);
            const savedService = safeParse('service');
            const savedPayment = safeParse('payment');

            setBrandsState(savedBrands);
            setModelsState(savedModels);
            setProductTypesState(savedProductTypes);
            setStageState(savedStage);
            setServiceState(savedService);
            setPaymentState(savedPayment);
        } catch (error) {
            console.warn('Failed to restore session from sessionStorage:', error);

        }
    }, []);
    const setBrands = (data) => {
        setBrandsState(data);
        sessionStorage.setItem('brands', JSON.stringify(data));
    };

    const setModels = (data) => {
        setModelsState(data);
        sessionStorage.setItem('models', JSON.stringify(data));
    };

    const setProductTypes = (data) => {
        setProductTypesState(data);
        sessionStorage.setItem('productTypes', JSON.stringify(data));
    };

    const setStage = (data) => {
        setStageState(data);
        sessionStorage.setItem('stage', String(data));
    };

    const setService = (data) => {
        setServiceState(data);
        sessionStorage.setItem('service', JSON.stringify(data));
    };

    const setPayment = (data) => {
        setPaymentState(data);
        sessionStorage.setItem('payment', JSON.stringify(data));
    };

    const hasBrands = brands.length > 0;
    const hasModels = models.length > 0;
    const hasProductTypes = productTypes.length > 0;

    const resetSession = () => {
        sessionStorage.clear();
        setBrands([]);
        setModels([]);
        setProductTypes([]);
        setStage(0);
        setService(null);
        setPayment(null);
    };

    return (
        <SessionContext.Provider
            value={{
                brands,
                setBrands,
                hasBrands,

                models,
                setModels,
                hasModels,

                productTypes,
                setProductTypes,
                hasProductTypes,

                stage,
                setStage,

                service,
                setService,

                payment,
                setPayment,

                resetSession,
            }}
        >
            {children}
        </SessionContext.Provider>
    );
}

export default SessionContext;